<template>
    <div class="button-switch" v-bind:class="[ isOn ? 'on' : '',editable ? 'editable' : '']" @click="toggle">
        <div class="handle">
            <div class="handle-center"></div>
        </div>
        <div class="title" v-bind:class="{transitioning:transitioning}">
            <span v-html="title" v-if="title != '' && (isOn || offMessage == '')"></span>
            <span v-html="offMessage" v-if="offMessage != '' && !isOn"></span>
        </div>
    </div>
</template>

<script>
    module.exports = {
        created:function() {
            this.isOn = this.on;
        },
        data:function() {
            return {
                isOn:false,
                transitioning:false
            }
        },
        props: {
            on:{type:Boolean,default:false},
            title:{type:String,default:''},
            offMessage:{type:String,default:''},
            save:{type:String,default:''},
            field:{type:String,default:'toggle'},
            editable:{type:Boolean,default:true}
        },
        methods: {
            toggle:function() {
                if(this.editable) {
                    this.transitioning = true;
                    this.isOn = this.isOn ? false : true;
                    var e = this;
                    $.ajax({
                        url: this.save,
                        method: 'PATCH',
                        data: {
                            field: this.field,
                            value: this.isOn
                        },
                        success: function (data) {
                            if (data.status != 200) {
                                e.isOn = e.isOn ? false : true;
                            }
                        }
                    });
                }
            }
        },
        mounted:function() {

        }
    }
</script>
